import React, { useState, useEffect } from "react";
import Rotator from "../../../../../Assets/Images/ButtonLoadingIcon.svg";
import axios from "axios";
import { Config } from "../../../../../Config";

const SessionTimeout = (props) => {
  const [IsLoading, setIsLoading] = useState(false);
  const [Duration, setDuration] = useState();
  const [Id, setId] = useState(""); //used for API data in PUT method for updating the timeout duration
  const [ChatbotTimeout, setChatbotTimeout] = useState();
  const [ChatbotWarningTimeout, setChatbotWarningTimeout] = useState();
  const [ChatbotTimeoutId, setChatbotTimeoutId] = useState("");

  useEffect(() => {
    getTimeoutDurations(); // session timeout for the whole application + chatbot timeout duration
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // fetches application general configs
  const getTimeoutDurations = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/session-timeout",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        let TimeoutItem = Res.data.filter((Item) => {
          return Item.name === "SESSION_TIMEOUT_MINUTES";
        });

        let ChatbotTimeoutItem = Res.data.filter((Item) => {
          return Item.name === "CHATBOT_SESSION_TIMEOUT_MINUTES";
        });

        let ChatbotWarningTimeoutItem = Res.data.filter((Item) => {
          return Item.name === "CHATBOT_SESSION_TIMEOUT_WARNING_MINUTES";
        });

        let TimeoutCheckbox = Res.data.filter((Item) => {
          return Item.name === "SESSION_ENDED_ON_BROWSER_CLOSED";
        });

        if (TimeoutCheckbox[0].value == "false") {
          document.getElementById("timeout-checkbox").checked = true;
          window.localStorage.setItem("SESSION_ENDED_ON_BROWSER_CLOSED", false);
        } else {
          window.localStorage.setItem("SESSION_ENDED_ON_BROWSER_CLOSED", true);
        }

        setId(TimeoutItem[0].id);
        setDuration(parseInt(TimeoutItem[0].value));
        setChatbotTimeout(parseInt(ChatbotTimeoutItem[0].value));
        setChatbotTimeoutId(ChatbotWarningTimeoutItem[0].id);
        setChatbotWarningTimeout(parseInt(ChatbotWarningTimeoutItem[0].value));
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const disableSaveBtn = () => {
    props.SetHasUnsavedChanges(false);
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
  };
  const enableSave = () => {
    props.SetHasUnsavedChanges(true);
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
  };

  // First validation is session timeout and if that is passed, second validation happens on
  // chatbot timeout. Save API call functions are called after each other.
  const validateEntries = () => {
    var TimeoutValue = document.getElementById("minutes").value;
    var ChatbotTimeout = document.getElementById("chatbot-minutes").value;
    var ChatbotWarningTimeout = document.getElementById(
      "chatbot-warning-minutes"
    ).value;

    // validation for session timeout value
    if (TimeoutValue.length === 0) {
      document.getElementById("minutes").classList.add("wrong-state");
      window.localStorage.setItem("HasUnsaveChanges", 1);
    } else if (parseInt(TimeoutValue) <= 5 || parseInt(TimeoutValue) >= 120) {
      document.getElementById("validation-text").style.color = "#ff7474";
      document.getElementById("minutes").classList.add("wrong-state");
    } else {
      // validation for chatbot session timeout value
      if (ChatbotTimeout.length === 0) {
        document.getElementById("chatbot-minutes").classList.add("wrong-state");
        window.localStorage.setItem("HasUnsaveChanges", 1);
      } else if (
        parseInt(ChatbotTimeout) <= 5 ||
        parseInt(ChatbotTimeout) >= 120
      ) {
        document.getElementById("chatbot-validation-text").style.color =
          "#ff7474";
        document.getElementById("chatbot-minutes").classList.add("wrong-state");
      } else {
        // validation for chatbot session timeout value
        if (ChatbotWarningTimeout.length === 0) {
          document
            .getElementById("chatbot-warning-minutes")
            .classList.add("wrong-state");
          window.localStorage.setItem("HasUnsaveChanges", 1);
        } else if (
          parseInt(ChatbotWarningTimeout) <= 5 ||
          parseInt(ChatbotWarningTimeout) >= 120
        ) {
          document.getElementById(
            "chatbot-warning-validation-text"
          ).style.color = "#ff7474";
          document
            .getElementById("chatbot-warning-minutes")
            .classList.add("wrong-state");
        } else {
          setIsLoading(true);
          saveConfigurations();
        }
      }
    }
  };
  const handleInputChange = (Id, ValidationTextId) => {
    document.getElementById(Id).classList.remove("wrong-state");
    document.getElementById(ValidationTextId).style.color = "#8b96a6";
    enableSave();
  };
  const saveConfigurations = () => {
    // Application session timeout
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/session-timeout",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: Id,
        value: document.getElementById("minutes").value,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // chatbot session timeout notice
        let Req = {
          method: "PUT",
          baseURL:
            window._env_.API_URL +
            Config.AuthBaseURL +
            "/api/general-config/application-setting/session-timeout",
          headers: {
            Authorization: "Bearer " + window.localStorage.getItem("Token"),
            "Content-Type": "application/json",
          },
          data: {
            id: ChatbotTimeoutId,
            value: document.getElementById("chatbot-warning-minutes").value,
            name: "CHATBOT_SESSION_TIMEOUT_WARNING_MINUTES",
            type: "APPLICATION",
          },
        };
        axios(Req)
          .then((Res) => {
            console.log(Res);
            // chatbot session timeout
            let Req = {
              method: "PUT",
              baseURL:
                window._env_.API_URL +
                Config.AuthBaseURL +
                "/api/general-config/application-setting/chatbot-session-timeout",
              headers: {
                Authorization: "Bearer " + window.localStorage.getItem("Token"),
              },
              data: {
                value: document.getElementById("chatbot-minutes").value,
              },
            };
            axios(Req)
              .then((Res) => {
                console.log(Res);

                // Timeout checkbox configs save
                let Req = {
                  method: "PUT",
                  baseURL:
                    window._env_.API_URL +
                    Config.AuthBaseURL +
                    "/api/general-config/application-setting/session-ended-on-browser-closed",
                  headers: {
                    Authorization:
                      "Bearer " + window.localStorage.getItem("Token"),
                  },
                  data: {
                    value: !document.getElementById("timeout-checkbox").checked,
                  },
                };
                axios(Req)
                  .then((Res) => {
                    console.log(Res);
                    getTimeoutDurations();
                    setIsLoading(false);
                    disableSaveBtn();
                  })
                  .catch((Err) => {
                    console.log(Err);
                  });
              })
              .catch((Err) => {
                console.log(Err);
              });
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
      });
  };
  return (
    <div className="main-content security-settings app-settings-form">
      <div className="user-management-form">
        <section className="form-header">
          <h1>{translateText("timeout_session")}</h1>
          <div className="button-group">
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <section className="form-body single-field-form">
          <div className="row">
            <h1>
              {translateText("session_timeout_duration")}{" "}
              <p className="required">*</p>
            </h1>
            <input
              onChange={() => handleInputChange("minutes", "validation-text")}
              defaultValue={Duration}
              min={5}
              max={120}
              className="minutes"
              type="number"
              id="minutes"
            />
            <p className="info-text">{translateText("minutes")}</p>
          </div>
          <p className="margin-bottom margined-row" id="validation-text">
            {translateText("session_timeout_validation_text")}
          </p>
          <div className="row checkbox-row">
            <label className="blue-checkbox-rounded-label">
              <input
                onChange={() => enableSave()}
                type="checkbox"
                class="blue-checkbox"
                id={"timeout-checkbox"}
              />
              <i></i>
            </label>
            <h1>{translateText("system_login_settings_label")}</h1>
          </div>
          <p className="margin-bottom margined-row" id="validation-text">
            {translateText("system_login_settings_info")}
          </p>
          <div className="row ">
            <h1>
              {translateText("chatbot_timeout_duration")}{" "}
              <p className="required">*</p>
            </h1>
            <input
              onChange={() =>
                handleInputChange("chatbot-minutes", "chatbot-validation-text")
              }
              defaultValue={ChatbotTimeout}
              min={5}
              max={120}
              className="minutes"
              type="number"
              id="chatbot-minutes"
            />
            <p className="info-text">{translateText("minutes")}</p>
          </div>
          <p
            id="chatbot-validation-text"
            className="row-info-text margined-row"
          >
            {translateText("session_timeout_validation_text")}
          </p>
          <div className="row ">
            <h1>
              {translateText("trigger_chatbot_warning_message")}{" "}
              <p className="required">*</p>
            </h1>
            <input
              onChange={() =>
                handleInputChange(
                  "chatbot-warning-minutes",
                  "chatbot-warning-validation-text"
                )
              }
              defaultValue={ChatbotWarningTimeout}
              min={5}
              max={120}
              className="minutes"
              type="number"
              id="chatbot-warning-minutes"
            />
            <p className="info-text">{translateText("minutes")}</p>
          </div>
          <p id="chatbot-warning-validation-text">
            {translateText("session_timeout_validation_text")}
          </p>
        </section>
      </div>
    </div>
  );
};

export default SessionTimeout;
